import {RestService} from "@/services/rest/RestService";
import {AsyncHandlingAPIApi} from "@/api/pharma-master-async-handling";
import {AsyncHandlingCriteriaDto, PagedAsyncHandlingOverviewRestDto} from "@/api/pharma-master-async-handling/models";

export class AsyncHandlingRestService extends RestService {

    private apiService: AsyncHandlingAPIApi;


    protected constructor() {
        super();
        this.apiService = new AsyncHandlingAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().masterUrl);
    }

    public async findAsyncHandlings(criteria: AsyncHandlingCriteriaDto): Promise<PagedAsyncHandlingOverviewRestDto> {
        const response = await this.apiService.findAsyncHandlingsByAsyncHandlingCriteriaDto(
            criteria
        );

        return response.data;
    }
}
